import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SuperAdminDashboardComponent } from './super-admin-dashboard/super-admin-dashboard.component';
import { superAdminRoutes } from './super-admin.routing';
import { GridModule } from '@progress/kendo-angular-grid';
import { UtilsModule } from '../utils/utils.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';

import { DateInputsModule, TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { IntlModule } from '@progress/kendo-angular-intl';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// BrowserModule, // Removed as it should only be in AppModule
import { PrdSignupResubmitComponent } from './prd-signup-resubmit/prd-signup-resubmit.component';
import { SharedModule } from '../shared/shared.module';
import { MonitorPrdSignupComponent } from './prd-signup-resubmit/monitor-prd-signup/monitor-prd-signup.component';
// import { ProductsModule } from '../portal/products/products.module';

// Angular Material imports
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SignupSingleViewComponent } from './prd-signup-resubmit/signup-single-view/signup-single-view.component';
import { PortalUsersComponent } from './portal-users/portal-users.component';
import { UsersService } from '../services/users.service';
import { RoleManagementComponent } from './role-management/role-management.component';
import { UserManagementComponent } from './role-management/user-management/user-management.component';
import { ListRolesVsPrevComponent } from './role-management/list-roles-vs-prev/list-roles-vs-prev.component';
import { UserModalComponent } from './role-management/user-management/admin-users/users/user-modal/user-modal.component';
import { UserReportComponent } from './role-management/user-report/user-report.component';
import { UsersComponent } from './role-management/user-management/admin-users/users/users.component';
import { VerificationCodesComponent } from './prd-signup-resubmit/verification-codes/verification-codes.component';
@NgModule({
  declarations: [
    SuperAdminDashboardComponent,
    PrdSignupResubmitComponent,
    MonitorPrdSignupComponent,
    SignupSingleViewComponent,
    PortalUsersComponent,
    RoleManagementComponent,
    UserManagementComponent,
    ListRolesVsPrevComponent,
    UserModalComponent,
    UserReportComponent,
    UsersComponent,
    VerificationCodesComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(superAdminRoutes),
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    UtilsModule,
    DropDownsModule,
    InputsModule,
    TimePickerModule,
    BsDatepickerModule.forRoot(),
    DateInputsModule,
    IntlModule,
    SharedModule,
    // Angular Material modules
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatTooltipModule,
  ],
  providers: [UsersService],
})
export class SuperAdminModule {}
